module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('vue-loading', {
    attrs: {
      "type": "beat",
      "color": "#F07883",
      "size": {
        width: '50px',
        height: '50px'
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b72cbd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = 357
// module chunks = 0